export interface FiltersState {
  query: string
  categories: string[]
  applications: string[]
  benefits: string[]
  crops: string[]
}

export type FilterGroup = 'categories' | 'applications' | 'benefits' | 'crops'

export const emptyFilters: FiltersState = {
  query: '',
  categories: [],
  applications: [],
  benefits: [],
  crops: [],
}

export function activeFilterCount(f: FiltersState): number {
  return f.categories.length + f.applications.length + f.benefits.length + f.crops.length + (f.query ? 1 : 0)
}
